import { useEffect } from 'react';
import { useNavigate, useParams, Outlet } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import AppTextField from '../../../../components/common/forms/AppTextField';
import AppSelect from '../../../../components/common/forms/AppSelect';
import PageContainer from '../../../../components/common/PageContainer';
import { ITaskTypes, ICreateTaskType  } from './utils/taskTypes-utils';
import { SelectOptionType } from '../../../../components/common/forms/form-types';
import { TaskTypeSchema, TypePartsInitialValues } from './utils/schema';
import { useGetTaskTypesById, useUpdateTaskTypes, useCreateTaskTypes } from '../../../../hooks/useTaskTypes';

import { appColors, appStyles } from '../../../../theme';
import { usePermission } from "../../../../hooks/usePermissions";
import { Modules, Permissions } from "../../../Users/Roles/roles-utils";
import { Navigate } from 'react-router-dom';

const TaskTypeForm = () => {
  const hasAddPermission = usePermission(
    Modules.mmdTt.accessKey,
    Permissions.add
  );
  const hasEditPermission = usePermission(
    Modules.mmdTt.accessKey,
    Permissions.edit
  );
  const navigate = useNavigate();
  const currentTaskTypes = useGetTaskTypesById();
  const updateTaskTypes = useUpdateTaskTypes();
  const createTaskTypes = useCreateTaskTypes();
  const statusOptions: SelectOptionType[] = [{'id': 'true', 'label': 'Active' , 'value': 'true'},{'id': 'false', 'label': 'Inactive' , 'value': 'false'} ]

const { register, 
        handleSubmit,
        setValue,
        control,
        formState: { errors, isValid }
      } = useForm<ICreateTaskType>({
        defaultValues: currentTaskTypes.data! ? currentTaskTypes.data : TypePartsInitialValues,
        mode: 'onChange',
        resolver: yupResolver(TaskTypeSchema),
      });

  useEffect(() => {
  
    if (!currentTaskTypes.data) return;
    setValue("taskType", currentTaskTypes.data?.taskType);
    setValue("isActive", currentTaskTypes.data?.isActive ? 'true' : 'false');
    
  }, [currentTaskTypes.data, setValue]);

  if (!hasAddPermission && !hasEditPermission) return <Navigate to="/home" />;

  const onError = (err: typeof errors) => {
    console.error(err);
  };

  const onSubmit = (data : ICreateTaskType) => {
    if (currentTaskTypes.data) {
      updateTaskTypes.mutate(data);
    }
    else {
      createTaskTypes.mutate(data)
    }
  };

  const backTo = () => navigate('/service-task');
  
  return (
    <>
      <PageContainer
        title='Manage My Databases'
        subTitle='Equipment Master'
        controls={
          <Stack direction='row' gap={2}>
            <Button sx={{ backgroundColor: appColors.lightGray, color: 'black' }} onClick={backTo}>
              Cancel
            </Button>
            <Button
              onClick={handleSubmit(onSubmit, onError)}
              disabled={!isValid }
              disableElevation
              variant='contained'
              sx={{ textTransform: 'capitalize', borderRadius: 1.5 }}
            >
              Save
            </Button>
          </Stack>
        }
      >
        <Divider color='black' />
        <Stack
          component='form'
          height='100%'
          bgcolor='white'
          py={3}
          boxShadow={appStyles.shadow}
          borderRadius={1}
        >
          <Stack px={3} height='100%' overflow='auto' gap={1}>
          <Stack direction="row" justifyContent="space-between" width="100%" mt={3}>
            <Stack direction="column" gap={1.5} width="45%">   
              <AppTextField
                label="Task Type"
                labelAlignment="left"
                labelWidth='33%'
                fieldWidth= '67%'
                fontWeight={400}
                placeholder="Task Type"
                error={!!errors.taskType}
                helperText={errors.taskType?.message}
                {...register('taskType')}
              />
                <Controller
                    control={control}
                    name='isActive'
                    render={({ field }) => (
                      <AppSelect
                        label="Status"
                        disabled= {currentTaskTypes.data ? false : true}
                        labelAlignment="left"
                        labelWidth='33%'
                        fieldWidth= '67%'
                        fontWeight={400}
                        placeholder="Select here"
                        error={!!errors.isActive}
                        helperText={errors.isActive?.message}
                        options={statusOptions}
                        {...register('isActive')}
                        {...field}
                      />
                  )}
                />
               
            </Stack>
          </Stack>
          </Stack>
        </Stack>
      </PageContainer>
      <Outlet />
    </>
  )
}

export default TaskTypeForm;